import {
	applyAuditLogsFilter,
	applySnapshotHistoryFilter,
	focusAuditLog,
	openAuditLogsSection,
	openSnapshotHistorySection,
	openSystemLogsSection,
} from './adapter';
import {
	openAuditLogsFilterModal,
	openAuditLogsViewMoreModal,
} from './modal';
import {resolveAuditLogs} from './resolver';
import {serializeAuditLogsContext} from './context';

const auditLogsPlugin = {
	id: 'audit_logs',
	version: 1,
	commandVersion: 1,
	resource: 'audit_logs',
	operations: [
		'options',
		'view',
		'search',
		'filter',
		'refresh',
		'download_inventory',
		'view_more',
		'create',
		'edit',
		'delete',
	],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.audit_logs': openAuditLogsSection,
	},
	resolvers: {
		audit_log: resolveAuditLogs,
	},
	filters: {
		audit_log: applyAuditLogsFilter,
	},
	focusHandlers: {
		audit_log: focusAuditLog,
	},
	modals: {
		'audit_logs.filter': openAuditLogsFilterModal,
		'audit_logs.view_more': openAuditLogsViewMoreModal,
	},
	contextSerializers: {
		audit_logs: serializeAuditLogsContext,
	},
};

const snapshotHistoryPlugin = {
	id: 'snapshot_history',
	version: 1,
	commandVersion: 1,
	resource: 'snapshot_history',
	operations: ['options', 'view', 'search', 'refresh', 'download_inventory'],
	dependencies: {
		plugins: ['canvas.navigation', 'audit_logs'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.snapshot_history': openSnapshotHistorySection,
	},
	filters: {
		ap_snapshot: applySnapshotHistoryFilter,
	},
};

const systemLogsPlugin = {
	id: 'system_logs',
	version: 1,
	commandVersion: 1,
	resource: 'system_logs',
	operations: ['options', 'view', 'download_inventory'],
	dependencies: {
		plugins: ['canvas.navigation', 'audit_logs'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.system_logs': openSystemLogsSection,
	},
};

export {snapshotHistoryPlugin, systemLogsPlugin};
export default auditLogsPlugin;
